import "./TestimonialCard.css";
import { FaStar } from "react-icons/fa";
import ReactCountryFlag from "react-country-flag";
import API_CONFIG from "../config/api";

const TestimonialCard = ({ name, age, image, testimonial, rating, country, flag }) => {
  // Generate stars based on rating
  const renderStars = () => {
    return Array.from({ length: 5 }, (_, i) => (
      <FaStar key={i} className={i < rating ? "star filled" : "star"} />
    ));
  };

  return (
    <div className="testimonial-card">
      <div className="testimonial-content">
        <p className="testimonial-text">"{testimonial}"</p>

        <div className="testimonial-stars">{renderStars()}</div>

        <div className="testimonial-info">
          <h4 className="testimonial-name">{name}</h4>

          <div className="testimonial-details">
            <div className="testimonial-flag">
              <ReactCountryFlag
                countryCode={flag} // flag should be "PK", "US", "CA", etc.
                svg
                style={{
                  width: "1.5em",
                  height: "1.5em",
                  marginRight: "8px",
                }}
                title={country}
              />
              <span>From {country}</span>
            </div>

            <div className="testimonial-age">Age {age} Years</div>
          </div>
        </div>
      </div>

      <div className="testimonial-image">
        <img src={`${API_CONFIG.IMAGES_URL}/${image}`} alt={name} />
      </div>
    </div>
  );
};

export default TestimonialCard;
